import React from 'react';

import {SearchContactsTooltipOptions} from '../../../../../../../src/components/common/dropdowns/search/searchContactsDropdown';
import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';

export const accountDetailsContactsDropdownRenderTooltip = ({
  isDisabled,
  contactHandlesJoined,
  account,
}: SearchContactsTooltipOptions) => {
  // Don't render a tooltip as we already have one to clarify the
  // card's visibility
  if (!isDisabled || !account) {
    return null;
  }

  return <Trans id="account-details-contacts-contact-disabled">Already added to {account.name}</Trans>;
};
